export const supportedLngs = ["en", "ro", "ru"];